import React, { useEffect } from 'react';

//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

//Mansory - Bento grid
import Masonry from 'react-masonry-css';

//Iconos
import icn_01 from '../../assets/img/landingPage/orchestrator/icn_Orchestrator-03.png';
import icn_02 from '../../assets/img/landingPage/avap/avap_02_ai.svg';
import icn_03 from '../../assets/img/landingPage/cloudP/icn_cloudP_03.png';
import icn_04 from '../../assets/img/landingPage/cloudP/icn_cloudP_04.png';
import icn_05 from '../../assets/img/landingPage/cloudP/icn_cloudP_05.png';
import icn_06 from '../../assets/img/landingPage/cloudP/icn_cloudP_06.png';
import icn_07 from '../../assets/img/landingPage/cloudP/icn_cloudP_07.png';
import icn_08 from '../../assets/img/landingPage/cloudP/icn_cloudP_08.png';

import key_01 from '../../assets/img/landingPage/integration/integration-03.png'
import key_02 from '../../assets/img/landingPage/cognitive/cognitive_01.png'
import key_03 from '../../assets/img/landingPage/cognitive/cognitive_02.png'
import key_04 from '../../assets/img/landingPage/connectors/Connectors_03.png'
import key_05 from '../../assets/img/landingPage/vision/Vision03.png'

import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

import product_gateway from '../../assets/img/landingPage/Gateway.png'
import dashboard from '../../assets/img/landingPage/cloud/Cloud-home.png';

import icn_vision from '../../assets/img/landingPage/about/aboutUs_vision.svg';
import icn_mision from '../../assets/img/landingPage/about/aboutUs_mision.svg';


const CognitiveAutomation = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
        Key_Feature_01: {
            title: 'AVAP Virtual Server',
            text: "Model smart workflows with dynamic conditions and rules",
            altDescription: "Model smart workflows with dynamic conditions and rules",
            image: key_01,
        },
        Key_Feature_02: {
            title: "AVAP Dev Language",
            text: "Build Virtual APIs with embedded logic and automation triggers",
            altDescription: "Build Virtual APIs with embedded logic and automation triggers",
            image: key_02,
        },
        Key_Feature_03: {
            title: 'Brunix AI & LLMs',
            text: "Add semantic understanding and predictive reasoning",
            altDescription: 'Add semantic understanding and predictive reasoning',
            image: key_03,
        },
        Key_Feature_04: {
            title: 'AVAP Connectors',
            text: 
            " Integrate across systems, legacy or modern",
            altDescription: ' Integrate across systems, legacy or modern',
            image: key_04,
        },
        Key_Feature_05: {
            title: 'AVAP Vision / AI Analytics',
            text: 
            "Gain real-time visibility and optimize performance",
            altDescription: ' Gain real-time visibility and optimize performance',
            image: key_05,
        },
    }
    

    
    const items = [
        {
            icon: icn_01,
            title: 'Cognitive Automation',
            paragraphs: [
              'Cognitive Automation brings intelligence into workflows. By applying technologies like natural language processing (NLP), computer vision, and machine learning, it enables systems to interpret context, make decisions, and evolve over time.',
            ],
            paragraphs2: [
                'Capabilities include:',
              ],
            bullets: [
              'Extracting key data from documents like invoices, contracts, or forms',
              'Understanding and routing emails, chats, and service tickets',
              'Classifying and processing requests based on semantic context',
              'Learning from outcomes to improve future performance',
            ],
           
            paragraphs3: [
              '',
            ],
          },

        {
          icon: icn_02,
          title: 'Intelligent Process Automation (IPA)',
          paragraphs: [
            'IPA is a holistic approach that integrates:',
          ],
          paragraphs2: [
            '',
          ],
          bullets: [
            'RPA for rule-based task automation',
            'Cognitive AI for interpreting data and context',
            'Process orchestration to coordinate people, systems, and bots',
            'Real-time analytics to monitor and optimize execution'
          ],
          paragraphs3: [
            'The goal? End-to-end automation—not just faster workflows, but smarter ones.',
          ],
          
        },
        
      ];
      
    const breakpointColumnsObj = {
        default: 2, //Cambio de columnas verticales
        1100: 2,
        700: 1          
    };

    //Key UseCases Bento
    const items2 = [
        {
            icon: icn_03,
            title: 'SaaS Startups',
            paragraphs: [
              'Legacy capabilities are exposed via modern APIs.'
            ]
          },
        {
            icon: icn_04,
            title: 'Public Institutions & Education',
            paragraphs: [
              'Data is cached securely for real-time access.'
            ]
          },
        {
          icon: icn_05,
          title: 'Agencies and Integrators',
          paragraphs: [
            'Workflows are orchestrated through AVAP Virtual Server.',
          ]
        },
        {
            icon: icn_06,
            title: 'Fintech Startups',
            paragraphs: [
              'Apps, CRMs, and external systems are integrated via AVAP Gateway.',
            ]
          },      
         
      ];
      
    const breakpointColumnsObj2 = {
        default: 4, //Cambio de columnas verticales
        1100: 2,
        700: 1          
    };
      

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" className="text-center py-5">

                    <h1 className="fl-title-big m-0 fl-txt-container-s">Cognitive Automation & IPA</h1>
                    <p className="fl-title m-0 gradient-text fl-txt-container-s">Go beyond task automation — design intelligent, self-optimizing workflows.</p>
                                {/*<p className="fl-text fl-txt-container" >
                                Empower every team to automate work faster and smarter with AVAP Framework’s virtual-first, low-code platform — 
                                built to orchestrate tasks, data, and systems for both humans and AI agents.
                                </p>*/}
                </section>

                {/* Subtítulo descripción */}
                <section className="text-center pb-5">
                    {/*<img
                        src={dashboard}
                        className="img-fluid mt-2 mb-4"
                        style={{ width: '70%', maxWidth: '800px', height: 'auto' }}
                    />*/}             
                    <h2 className="fl-subtitle pt-4">Rethink automation with AI at the core</h2>
                    <p className="fl-text text-center fl-txt-container-s">
                    Traditional automation handled repetitive tasks. Today’s organizations demand more—systems that understand, learn, and adapt. </p>
                    <p className="fl-text text-center fl-txt-container-s">
                    Cognitive Automation and Intelligent Process Automation (IPA) combine the power of AI and automation to transform how businesses operate. From complex decisions to unstructured data, this new wave of automation is built for flexibility, speed, and scale. </p>
                    {/*Boton Contact Us*/}  
                    <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a>
                   
                    
                    <br />
                    &nbsp;
                    <br />&nbsp;
                    
                    {/*<h2 style={{ marginTop: '40px' }} className="fl-title m-0 gradient-text fl-title m-4">Why AVAP for Cloud Providers?</h2>

                   
                        <ul className="fl-bullets fl-text text-center .fl-txt-container-s">
                        <li className="fl-bullets">Expand your service offering with high-value API Management</li>
                        <li className="fl-bullets">Increase average revenue per customer with integrated, add-on services</li>
                        <li className="fl-bullets">Provide full-featured API monitoring, control, and security</li>
                        <li className="fl-bullets">Deliver everything under your brand with flexible integration options</li>
                        <li className="fl-bullets">Maintain complete control of customer experience and business model</li> </ul>*/}
                        
                </section>
              

                <br />
                &nbsp;
                <br />&nbsp; 
               
                {/*<section className="container py-5 fl-gradientContainer mb-5" >
                <p className="fl-title-center m-0">Two Deployment Models</p><br />
                <p className="fl-subtitle text-center m-0 gradient-text">One Scalable Platform.</p>
            
                &nbsp;
                <br />&nbsp;    
                 <div className="row">
                        <div className="col-md-6 d-flex">
                            <img
                                src={icn_vision}
                                alt="Icon representing vision."
                                className="aboutIcon"
                            
                            />
                            <h3 className="fl-subtitle">1. Direct Provider Model</h3>
                            <p className="fl-text">
                            Integrate AVAP API Management directly into your platform via service APIs:
                            </p>
                                
                                <ul className="fl-bullets fl-text fl-txt-container-s" style={{ marginLeft: "7px" }}>
                                <li className="fl-bullets">White-label the solution under your own brand</li>
                                <li className="fl-bullets">Automate provisioning, monitoring, and control from your UI</li>
                                <li className="fl-bullets">Offer a native API Management experience to your customers</li>
                                <li className="fl-bullets">Seamlessly connect to your CRM, billing, and service catalog</li>
                                </ul>
                                <br/>
                            <p className="fl-text">
                            <strong style={{ fontWeight: 600 }}>Best for:</strong> Self-service platforms and tech providers with their own customer-facing portals.
                            </p>
                        </div>
                        <div className="col-md-6 pl-5">
                            <img
                                src={icn_mision}
                                alt="Icon of arrows representing mission."
                                className="mb-3 aboutIcon"
                               
                            />
                            <h3 className="fl-subtitle">2. Reseller Model</h3>
                            <p className="fl-text">
                            Distribute AVAP API Management as a ready-to-use platform:
                            </p>
                        
                                <ul className="fl-bullets fl-text  .fl-txt-container-s" style={{ marginLeft: "7px" }}>
                                <li className="fl-bullets">Control users, environments, consumption, and billing</li>
                                <li className="fl-bullets">Access to multitenant environments and centralized management</li>
                                <li className="fl-bullets">Full support and operations handled by AVAP experts</li>
                                </ul>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                            <p className="fl-text">
                            <strong style={{ fontWeight: 600 }}>Best for:</strong> Infrastructure providers looking to add robust services without complex development.
                            </p>  
                        </div>
                          
                        <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a> 
                    </div>
                            </section>*/}

                {/*Sección Tipos de Deployments */}
                <div className="container fl-gradientContainer my-5 p-5">
                {/*<div className="fl-title text-center mb-6">
                Cognitive Automation // Intelligent Process Automation
                {/*<p className="fl-subtitle text-center m-0 gradient-text">One Scalable Platform.</p>
                </div>*/}
            
                    <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items.map((item, idx) => (
                        <div key={idx} className="fl-card">
                        <img src={item.icon} alt="Icon representing 0X" className="solutionsIcon" />
                        <p className="fl-subtitle-xs">{item.title}</p>
                        {item.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                        ))}
                         {item.paragraphs2.map((p, i) => (
                            <p key={i} className="fl-text bold">{p}</p>
                        ))}
                        
                        {item.bullets && (
                            <ul className="fl-bullets fl-text fl-txt-container-s" style={{ marginLeft: '7px' }}>
                            {item.bullets.map((b, i) => (
                                <li key={i} className="fl-bullets">{b}</li>
                            ))}
                            </ul>
                        )}
                        {item.paragraphs3.map((p, i) => (
                            <p key={i} className="fl-text bold pt-4">{p}</p>
                        ))}
                        </div>
                    ))}
                    </Masonry>
                    {/*Boton Contact Us*/}  
                    <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a>
                </div>

                {/* Sección Key Features */}
                <div className="fl-wrapper">
                    <img src={gradientServices} className="gradient gradientServices" alt="" />
                    <img src={gradientApi} alt="" className="gradient gradientlife" />
                    <div className="fl-container">
                        <section id="products">
                            {/*   <h3 className="fl-title text-center">Our Products & Services</h3> */}
                            <br />
                            &nbsp;
                            <br />&nbsp;
                            <p className="fl-title-center fl-txt-container-s">How AVAP Framework Powers Cognitive Automation & IPA</p>
                            <p className='fl-subtitle text-center gradient-text fl-txt-container-s'>AVAP helps you go beyond task automation, into truly intelligent orchestration.</p>
                            <div className="fl-productsWrapper">
                                {Object.keys(productDetailsA).map((productKey, index) => (
                                    <div key={productKey} className="fl-product-item">
                                        <div className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}>
                                            <div className="col-md-6">
                                                <div className="product-content">
                                                    <h3 className="fl-subtitle">
                                                        {productDetailsA[productKey].title}
                                                    </h3>
                                                    <p className="fl-text">
                                                        {productDetailsA[productKey].text}
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <img
                                                    src={productDetailsA[productKey].image}
                                                    alt={productDetailsA[productKey].altDescription}
                                                    className="img-fluid product-preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </div>
                </div>

                <section className="text-center pb-5"> 
                    <h2 className="fl-title text-center mb-3 fl-txt-container-s" >AVAP is designed for automation-first architectures. </h2>
                    <p className="fl-subtitle text-center fl-txt-container-s">
                    Whether you're automating claims processing, smart onboarding, or healthcare scheduling, AVAP provides the intelligence and flexibility you need.</p>
                    {/*<p className="fl-text text-center fl-txt-container-s">
                    From robotic tasks to cognitive execution—AVAP powers your next-gen workflows.
                                Let’s design intelligent systems that learn, adapt, and grow with your business.</p>]*/}
                </section>

                {/*Boton Contact Us*/}  
                <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a>

            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default CognitiveAutomation;
